import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import qs from 'qs';
import { toast } from 'react-toastify';
import { API_URL } from '../../../../../utils/config';
import Helpers from '../../customers/helpers/utils';

const COUNTRY_CODES = { nigeria: '234', ghana: '233' };

// Termii expects the number in international format without "+", e.g. 2348126533425
const formatNumber = (raw, country) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  const code = COUNTRY_CODES[String(country || '').toLowerCase()] || COUNTRY_CODES.nigeria;
  if (digits.startsWith(code)) return digits;
  if (digits.startsWith('0')) return `${code}${digits.slice(1)}`;
  return `${code}${digits}`;
};

const SendTermiBulkSms = ({ show, onClose, data }) => {
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');

  const numbers = Array.from(new Set(data.map((d) => formatNumber(d.phone, d.country)).filter(Boolean)));

  const onSend = async () => {
    if (!numbers.length || !msg.trim() || sending) return;
    setSending(true);
    const results = await Promise.all(
      numbers.map((number) =>
        axios
          .post(`${API_URL}/sms/send`, qs.stringify({ number, msg: msg.trim() }), {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          })
          .then(() => true)
          .catch(() => false),
      ),
    );
    setSending(false);
    const sent = results.filter(Boolean).length;
    const failed = results.length - sent;
    if (sent) toast.success(`Termi SMS sent to ${sent} customer${sent > 1 ? 's' : ''}`);
    if (failed) toast.error(`Unable to send Termi SMS to ${failed} customer${failed > 1 ? 's' : ''}`);
    if (!failed) onClose();
  };

  return (
    <Modal show={show} onHide={sending ? undefined : onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ paddingLeft: '2rem' }}>Send Termi SMS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Send SMS via Termi to <strong>{numbers.length}</strong> selected customer{numbers.length === 1 ? '' : 's'}?
        </p>
        <select
          className="form-control border border-info py-2 mb-3"
          defaultValue=""
          onChange={(e) => setMsg(e.target.value ? Helpers.messageToBeSent(e.target.value) : '')}
        >
          <option value="">--Select Template (optional)--</option>
          <option value="NEW INSTALLS">NEW INSTALLS</option>
          <option value="ACTIVE CUSTOMERS">ACTIVE CUSTOMERS</option>
          <option value="EXPIRED CUSTOMERS">EXPIRED CUSTOMERS</option>
        </select>
        <textarea
          className="form-control border border-info py-2 mb-3"
          rows={5}
          placeholder="Type your message"
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
        />
        <div className="text-center">
          <button
            type="button"
            className="btn btn-green"
            onClick={onSend}
            disabled={sending || !numbers.length || !msg.trim()}
          >
            {sending ? 'Sending SMS...' : 'Send Termi SMS'}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SendTermiBulkSms;
